// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"497":"7c229ed5","767":"15f9cd04"}[chunkId] + ".css";
};